"use client";

import { GailMessageFeedback } from "@repo/ui/gailgpt/message-feedback";
import type { FeedbackCategory, FeedbackRating } from "@/types/feedback";

interface MessageFeedbackProps {
   messageId: string;
   currentRating?: FeedbackRating;
   onFeedback: (
      messageId: string,
      rating: FeedbackRating | null,
      categories?: FeedbackCategory[],
      comment?: string
   ) => void | Promise<void>;
}

export default function MessageFeedback({
   messageId,
   currentRating,
   onFeedback,
}: MessageFeedbackProps) {
   return (
      <GailMessageFeedback
         rating={currentRating}
         onFeedback={(rating, categories, comment) =>
            categories || comment
               ? onFeedback(messageId, rating, categories, comment)
               : onFeedback(messageId, rating)
         }
      />
   );
}
